import React from 'react';
import { ActivityWidget } from './ActivityWidget';
import { ActivityChartWidget } from './ActivityChartWidget';
import { HealthWidget } from './HealthWidget';
import { QuickActionsWidget } from './QuickActionsWidget';
import { DesignVariantWidget } from './DesignVariantWidget';

/**
 * The dashboard's widget register.
 *
 * The dashboard page renders whatever is here, in whatever order the
 * administrator has arranged, so adding a panel is a register entry rather than
 * an edit to a layout. Each entry declares its own width in columns; nothing
 * about position lives in the widget itself.
 *
 * `title` is what the arrangement editor and the error boundary call the panel,
 * so a failed widget is still identifiable by name.
 */
export interface WidgetDefinition {
  id: string;
  title: string;
  /** How much of the three-column grid this panel occupies. */
  span: 1 | 2;
  render: () => React.ReactNode;
}
export const dashboardWidgets: WidgetDefinition[] = [{
  id: 'activity-chart',
  title: 'Recorded administrative activity',
  span: 2,
  render: () => <ActivityChartWidget data-id="element-532" data-mp="2ehhlloksq822" />
}, {
  id: 'quick-actions',
  title: 'Quick actions',
  span: 1,
  render: () => <QuickActionsWidget data-id="element-533" data-mp="2afnqdvtddw9a" />
}, {
  id: 'activity',
  title: 'Recent activity',
  span: 2,
  render: () => <ActivityWidget data-id="element-534" data-mp="25hm5r6gapovp" />
}, {
  id: 'health',
  title: 'System health',
  span: 1,
  render: () => <HealthWidget data-id="element-535" data-mp="20hzuv3nxwkq2" />
}, {
  id: 'design-variants',
  title: 'Design variants',
  span: 1,
  render: () => <DesignVariantWidget data-id="element-536" data-mp="1vq7z8epxfot2" />
}];